import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";

const IdleTimerComponent = () => {
    const navigate = useNavigate();

    const handleIdle = () => {
        navigate("/logout");
    };

    useIdleTimer({
        timeout: 600000, // Specify the idle timeout in milliseconds 
        onIdle: handleIdle,
    });
};

export default IdleTimerComponent;
